var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('div',[_c('apexchart',{attrs:{"width":_vm.width,"height":_vm.height,"type":"bar","options":_vm.options,"series":_vm.series}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }